import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';
import {ProjectStatus} from '../../project-misc/data/project/statuses/project-status';
import {ActivityDuration} from './activity-duration';


export interface ActivityConditionBlock {
  title: string;
  conditions: ActivityForEdit[]
}

@JsonObject('model.ActivityForEdit')
export class ActivityForEdit extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'name')
  name?: string;

  @JsonProperty(String, 'title')
  title?: string;

  @JsonProperty(String, 'color')
  color?: string;

  @JsonProperty(Number, 'minDuration')
  minDuration?: number;

  @JsonProperty(String, 'startTime')
  startTime?: string;

  @JsonProperty(String, 'endTime')
  endTime?: string;

  @JsonProperty(Number, 'maxCountPerProject')
  maxCountPerProject?: number;

  @JsonProperty(Boolean, 'preventOverlapping')
  preventOverlapping?: boolean;

  @JsonProperty(Boolean, 'respectManualControl')
  respectManualControl?: boolean;

  @JsonProperty(Boolean, 'restrictWeekend')
  restrictWeekend?: boolean;

  @JsonProperty([String], 'roles')
  roles?: string[];

  @JsonProperty(String, 'shortCode')
  shortCode?: string;

  @JsonProperty([ActivityDuration], 'durations')
  durations?: ActivityDuration[];
}
